module.exports = __webpack_public_path__ + "media/images/hotel-equipment-7fed2eef11bd14f6a9d35055e347866c.png";